<script>
import {useConfig} from '@/helpers/config-effect';
import {slugify} from '@/helpers/strings';

export default {
  name: 'TriggerSettings',
  template: '#trigger-settings-template',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const config = useConfig();

    const triggerSchedules = config.triggers.schedules;
    const eventGroups = {};

    Object.values(config.triggers.events).forEach(triggerEvent => {
      if (!eventGroups.hasOwnProperty(triggerEvent.group)) {
        eventGroups[triggerEvent.group] = {
          name: triggerEvent.group,
          events: [],
        };
      }

      eventGroups[triggerEvent.group].events.push(triggerEvent);
    });

    eventGroups['other'] = {name: 'Other', events: [{id: 'custom', name: 'Custom', group: 'Other'}]};

    const triggerTypes = {
      schedule: {
        label: 'Scheduled',
        description: 'Hourly, weekly, etc...',
        icon: 'update',
      },
      event: {
        label: 'Event',
        description: 'Post creation, order creation, etc...',
        icon: 'bolt',
      },
      webhook: {
        label: 'WebHook',
        description: 'API Call, Zapier, etc...',
        icon: 'cloud',
      },
    };

    return {
      triggerTypes,
      eventGroups: Object.values(eventGroups),
      triggerSchedules,
      set webhookSlug(value) {
        props.node.property('arguments.webhook').slug = slugify(value, '-') || '';
      },
      get webhookSlug() {
        return props.node.property('arguments.webhook').slug;
      },
    };
  },
};
</script>
